import { render } from "./HelpCard.vue?vue&type=template&id=130214be"
import script from "./HelpCard.vue?vue&type=script&lang=js"
export * from "./HelpCard.vue?vue&type=script&lang=js"

import "./HelpCard.vue?vue&type=style&index=0&id=130214be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/HelpCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "130214be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('130214be', __exports__)) {
    api.reload('130214be', __exports__)
  }
  
  module.hot.accept("./HelpCard.vue?vue&type=template&id=130214be", () => {
    api.rerender('130214be', render)
  })

}


export default __exports__